module.exports = __webpack_public_path__ + "static/new-assignment-d0292902877df0b35caf9fb4b82c7706.png";